"use client";

import type {
  LocationSearchFormBreakpoint,
  LocationSearchFormClassNames,
} from "~www/components/LocationSearchForm/LocationSearchForm";

import { cn } from "@homeinstead/ui";
import { useRouter } from "next/navigation";
import LocationSearchForm from "~www/components/LocationSearchForm/LocationSearchForm";

interface SearchAreaProps {
  heading: string;
  className?: string;
  headingClassName?: string;
  buttonText?: string;
  placeholder?: string;
  showCurrentLocation?: boolean;
  targetUrl?: string;
  horizontalBreakpoint?: LocationSearchFormBreakpoint;
  defaultQuery?: string;
  slotClassNames?: LocationSearchFormClassNames;
}

export function SearchArea({
  heading,
  className,
  headingClassName,
  buttonText = "Search Jobs",
  placeholder,
  showCurrentLocation = true,
  targetUrl,
  horizontalBreakpoint,
  defaultQuery,
  slotClassNames,
}: SearchAreaProps) {
  const router = useRouter();
  const handleSubmit = (place: string) => {
    router.push(`${targetUrl || ""}?q=${encodeURIComponent(place)}`);
  };

  return (
    <div className={cn("flex w-full flex-col gap-6 lg:gap-10", className)}>
      <h1
        className={cn(
          "text-center font-bold text-lg text-new-beginnings-base leading-8",
          headingClassName,
        )}
      >
        {heading}
      </h1>

      <LocationSearchForm
        buttonText={buttonText}
        defaultValue={defaultQuery}
        horizontalBreakpoint={horizontalBreakpoint}
        onSubmit={handleSubmit}
        placeholder={placeholder}
        showCurrentLocation={showCurrentLocation}
        slotClassNames={slotClassNames}
      />
    </div>
  );
}
